import {api,type DisputeProposal} from "../../lib/api";
import {AgreementDocument} from "../AgreementDocument";

export function SettlementRecord({id,proposal,busy,run}:{id:string;proposal:DisputeProposal;busy:boolean;run:(action:()=>Promise<unknown>)=>Promise<void>}) {
 return proposal.document ? <details className="mt-3 border-t border-line pt-2 text-sm">
  <summary className="min-h-11 cursor-pointer py-3 font-semibold">Full Settlement document · version {proposal.version}</summary>
  <AgreementDocument document={proposal.document}/>
  <button type="button" disabled={busy} className="btn-outline min-h-11" onClick={()=>void run(()=>api.downloadDisputeDocument(id,"settlement",proposal.id))}>Download Settlement PDF</button>
 </details> : <p className="mt-3 text-xs text-mut">No full Settlement document was created for this proposal.</p>;
}
